import { createAsyncThunk } from '@reduxjs/toolkit';
import { PaymentMethod } from '@wix/cashier-common/dist/src/enums/payments/PaymentMethod';
import { PaymentProvider } from '@wix/cashier-common/dist/src/enums/payments/PaymentProvider';
import { type BiLogger } from '../../components/Provider/BiLogger/BiLogger';
import { type GooglePayReadyToPayChangeResponse } from '../../components/payment-methods/GooglePay/types';
import { selectTopProps } from '../../selectors';
import { type PaymentsButtonPlace } from '../../types/PaymentsButtonViewConfig';
import { type StoreState } from '../../types/StoreState';
import { amountToLong } from '../../utils/amountToLong';
import { perfNow } from '../../utils/perfNow';
import { spbButtonRendered } from '../../utils/bi/events/biEvents';
import { setGooglePayButtonVisibility } from './common';

type OnReadyToPayChangeParams = {
  biLogger: BiLogger;
  readyToPayState: GooglePayReadyToPayChangeResponse;
  place: PaymentsButtonPlace;
};

export type OnReadyToPayChangeReturn = Promise<{}>;

export const onReadyToPayChange = createAsyncThunk<
  OnReadyToPayChangeReturn,
  OnReadyToPayChangeParams,
  {
    state: StoreState;
  }
>('GOOGLE_ON_READY_TO_PAY_CHANGE', async ({ biLogger, readyToPayState, place }, { dispatch, getState }) => {
  const topProps = selectTopProps(getState());
  const { paymentAmount, currency, meta, loadInfo } = topProps;

  if (readyToPayState.isButtonVisible) {
    biLogger.report(spbButtonRendered, {
      renderPlace: place,
      paymentProvider: PaymentProvider.WixPayUS,
      paymentmethod: PaymentMethod.GooglePay,
      loadTime: Math.floor(perfNow() - loadInfo.loadStartTime),
      cartId: meta.cartId,
      productId: meta.productId,
      currency,
      amount: amountToLong(paymentAmount),
      isPartner: undefined as any, // TODO[bi]
      orderSnapshotId: undefined as any, // TODO[bi]
      transactionId: undefined as any, // TODO[bi]
    });
  }

  dispatch(setGooglePayButtonVisibility(readyToPayState.isButtonVisible ? 'visible' : 'hidden'));

  return {};
});
